<template>
  <div v-show="visible" class="demo-bar">
    <div class="container py-0">
      <div class="demo-inner">
        <span class="demo-button">{{ $t('DEMO_001') }}</span>
        <span class="demo-msg">{{ $t('DEMO_002') }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.demo-bar {
  font-size: 14px;
  line-height: 22px;
  min-height: 80px;
  background-color: #fff576;

  .demo-inner {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .demo-button {
    font-size: 16px;
    color: #fff !important;
    min-width: 125px;
    height: 40px;
    display: inline-block;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    background-color: #ff0000;
  }
}

@media print, screen and (min-width: 480px) {
  .demo-bar {
    font-size: 16px;
    display: flex;
    align-items: center;

    .demo-button {
      font-size: 18px;
    }

    .demo-inner {
      display: flex;
      align-items: center;
    }
  }
}
</style>

<script>
export default {
  name: 'DemoBar',
  props: {
    visible: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {};
  }
};
</script>
